<template>
    <el-input v-model="FilterPalmNumber" type="number" min="0" placeholder="Palm Number" @input="handleInput($event)" />
</template>

<script>
export default {
    data() {
        return {
            FilterPalmNumber: null
        };
    },
    methods: {
        handleInput: _.debounce(function(e) {
            this.$emit("handleInput", e);
        }, 500)
    },
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/smallComponents/Form/PalmNumber.vue